module.exports = __webpack_public_path__ + "static/media/transfer-ips-icon.566820f8.svg";